import angular from 'angular';

import component from './kitchen-details.ng1.component';

export default angular
    .module('control-room.menus.components.kitchen-details', [])
    .component('crKitchenDetails', component);
